import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=fe6146a4&scoped=true&"
import script from "./Food.vue?vue&type=script&lang=js&"
export * from "./Food.vue?vue&type=script&lang=js&"
import style0 from "./Food.vue?vue&type=style&index=0&id=fe6146a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6146a4",
  null
  
)

export default component.exports